module.exports = __webpack_public_path__ + "static/img/comics.0fa103d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/element/Menu/img/items/comics.png
// module id = 197
// module chunks = 0